/* eslint-disable react/require-default-props */
import React, { FC, ReactElement } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import {
  List,
  ListItem,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { MailOutline as MailIcon } from '@material-ui/icons'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import DraftsIcon from '@material-ui/icons/Drafts'

import ManeuverStatus from '../../ManeuverStatus'

import { RecentTouch, Prospects as ProspectsStore } from '../../../../stores/prospects'

interface Props extends RouteComponentProps {
  recentTouches?: Array<RecentTouch>
  prospects?: ProspectsStore
}
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}))

const isDateInPast = (date: string): boolean => {
  const dt = new Date(date)
  const offset = 240 // Timezone offset for EST in minutes.
  const estDate = new Date(dt.getTime() + offset * 60 * 1000)
  const todaysDate = new Date()
  if (estDate <= todaysDate) {
    return true
  }
  return false
}

const nextSendDate = (sendDates: Array<RecentTouch>): number => {
  let localNextSendDate = 0
  sendDates.forEach(date => {
    if (localNextSendDate === 0) {
      const dt = new Date(date[1])
      const offset = 240 // Timezone offset for EST in minutes.
      const estDate = new Date(dt.getTime() + offset * 60 * 1000)
      const todaysDate = new Date()
      if (estDate <= todaysDate) {
        return
      }
      localNextSendDate = Number(estDate)
    }
  })
  return localNextSendDate
}
const formatDate = (date: string): string => {
  let formattedDate = date
  const month = formattedDate.substring(5, 7)
  const day = formattedDate.substring(8, 10)
  const year = formattedDate.substring(0, 4)
  formattedDate = `${month}/${day}/${year}`
  return formattedDate
}
const buildIcon = (date: string, open: number): ReactElement => {
  if (isDateInPast(date)) {
    if (open > 0) {
      return <DraftsIcon className="mailIcon active-mailIcon" />
    }
    return <MailIcon className="mailIcon active-mailIcon" />
  }
  return <MailIcon className="mailIcon" />
}

const HistoricalTouches: FC<Props> = ({ recentTouches, prospects }) => {
  const classes = useStyles()
  if (prospects?.prospect) {
    const { maneuver } = prospects.prospect
    return (
      <div className="recentTouches">
        {recentTouches && recentTouches?.length > 0 && nextSendDate(recentTouches) ? (
          <>
            <hr className="divider" />
            <Accordion className="historical-accordion">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <ManeuverStatus maneuver={maneuver} customSendDate={nextSendDate(recentTouches)} />
              </AccordionSummary>
              <AccordionDetails>
                <List className={classes.root}>
                  {recentTouches?.map(touch => (
                    <ListItem key={touch[1]}>
                      {buildIcon(touch[1], touch[4])}
                      <ListItemText
                        /* eslint-disable @typescript-eslint/indent */
                        primary={
                          touch
                            ? touch[0]
                                .replace('ft', 'Rev-up ')
                                .replace('n', 'Re-engage ')
                                .replace('fu', 'Engaged ')
                            : ''
                          /* eslint-enable @typescript-eslint/indent */
                        }
                        secondary={
                          touch ? (
                            <>
                              <Typography component="span" variant="body2" color="textPrimary">
                                {`Opens: ${touch[4] || 0}`}
                              </Typography>
                              <p>{formatDate(touch[1])}</p>
                            </>
                          ) : (
                            ''
                          )
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
            <hr className="divider" />
          </>
        ) : (
          <div>
            <hr className="divider" />
            <ManeuverStatus
              maneuver={maneuver}
              customSendDate={
                recentTouches && recentTouches?.length > 0 ? nextSendDate(recentTouches) : 0
              }
            />
            <hr className="divider" />
          </div>
        )}
      </div>
    )
  }
  return null
}

export default inject('prospects')(withRouter(observer(HistoricalTouches)))
